 <template>
  <router-view/>
</template>
 <script>
 import BlockAdresa from "@/components/general/view/blocks/BlockAdresa";
 import BlockCena from "@/components/general/view/blocks/BlockCena";
 export default {
   mounted() {
      //console.log("dev #APP mounted this.root_url,",  this.$rootUrl); //this.root_url,
   },
   created() {
      //console.log('dev App created')
   },
 };
 </script>
